module.exports = {"aspectRatio":1}